import * as React from 'react';

export interface LayoutProps {
  dataHook?: string;
  children?: React.ReactNode;
  className?: string;
  gap?: React.CSSProperties['gap'];
  cols?: number;
  justifyItems?: React.CSSProperties['justifyItems'];
  alignItems?: React.CSSProperties['alignItems'];
  rowHeight?: React.CSSProperties['gridAutoRows'];
}

export interface CellProps {
  dataHook?: string;
  children?: React.ReactNode;
  span?: number;
  vertical?: boolean;
  rows?: number;
}

export declare const Layout: React.FC<LayoutProps>;
export default Layout;

export declare const Cell: React.FC<CellProps>;
